module.exports = __webpack_public_path__ + "media/images/sp/special_reports/icon_hibiscus-14d203f4a12ba9dfb0fbc86285ad21b4.png";